<template>
  <router-view />
</template>
<script>
// import utils from "@/utils/utils";
import { mapMutations, mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("tableHeight", ["height"]),
  },
  mounted() {
    // this.$router.replace("/");
    let self = this;
    setInterval(() => {
      let tables = document.getElementsByClassName("tale-box");
      if (tables.length === 0) {
        self.change_height(0);
      } else {
        let height = tables[0].offsetHeight;
        self.change_height(height);
      }
    }, 1000);
    window.onresize = () => {
      let tables = document.getElementsByClassName("tale-box");
      if (tables.length === 0) {
        self.change_height(0);
      } else {
        let height = tables[0].offsetHeight;
        self.change_height(height);
      }
    };
  },
  methods: {
    ...mapMutations("tableHeight", ["change_height"]),
  },
};
</script>

<style lang="scss">
div,
p,
span,
ul,
li,
a,
input,
textarea,
h1,
h2,
h3,
h4,
ol,
h5,
h6,
select,
label,
i,
button {
  margin: 0;
  padding: 0;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: 14px;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  max-height: 100%;
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}

img {
  display: block;
  border: none;
}

button {
  background-color: transparent;
  border: 0;
  outline: none;
}

input {
  outline: none;
  border: none;
}

.mar-top-10 {
  margin-top: 10px;
}

.mar-top-20 {
  margin-top: 20px;
}

.mar-lf-10 {
  margin-left: 10px;
}

.mar-ri-20 {
  margin-right: 20px;
}

.mar-ri-10 {
  margin-right: 10px;
}

.mar-ri-auto {
  margin-right: auto;
}

.mar-lf-auto {
  margin-left: auto;
}

.mar-lf-20 {
  margin-left: 20px;
}

.mar-bom-10 {
  margin-bottom: 10px;
}

.order {
  .el-radio-button__inner:hover {
    color: #ec6a1a;
  }
  .el-radio-button__orig-radio:disabled:checked + .el-radio-button__inner {
    background-color: $bgColorActive;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: $bgColorActive;
    color: #ec6a1a;
    border-color: #ec6a1a;
    box-shadow: -1px 0 0 0 #ec6a1a;
  }
}
.hover {
  cursor: pointer;
}

.mar-bom-10 {
  margin-bottom: 10px;
}

.mar-lf-10 {
  margin-left: 10px;
}

.el-menu {
  border: 0 !important;
  .el-menu-item {
    // min-width: 180px !important;
  }
  .el-menu-item-top {
    min-width: unset !important;
    font-size: 14px;
    line-height: 62px;
  }
}
.el-tagCate {
  span {
    height: auto;
    line-height: 22px;
    padding-top: 5px;
    padding-bottom: 5px;
    white-space: wrap;
  }
}
.one-link-box {
  text-align: center;
  padding: 5px 0;
}
.moveInput {
  height: 40px;
  border: 1px solid #c0c4cc;
  padding: 0 15px;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
// .home .el-button--primary {
//   background-color: #ec6a1a;
//   border-color: #827acf;

//   &:hover {
//     background-color: #827acf;
//     border-color: #827acf;
//   }

//   &:focus {
//     background-color: #827acf;
//     border-color: #827acf;
//   }
// }

// .home .el-button.is-disabled {
//   background-color: #8a86af;
//   border-color: #8a86af;
// }

//橙色
//.home .el-button--default {
//  border: 1px solid #ec6a1a;
//  color: #ec6a1a;
//
//  &:hover {
//    border: 1px solid #f19b66;
//    color: #f19b66;
//    background-color: #fff;
//  }
//
//  &:focus {
//    border: 1px solid #f19b66;
//    color: #f19b66;
//    background-color: #fff;
//  }
//}
.home .el-button--primary.is-disabled,
.dialog-footer .el-button--primary.is-disabled {
  background-color: #e5baa0;
  border: 1px solid #e5baa0;
}
.home .el-button--primary,
.dialog-footer .el-button--primary {
  border: 1px solid #ec6a1a;
  color: #fff;
  background-color: #ec6a1a;

  &:hover {
    border: 1px solid #f19b66;
    color: #fff;
    background-color: #f19b66;
  }

  &:focus {
    border: 1px solid #f19b66;
    color: #fff;
    background-color: #f19b66;
  }
}

.sub .el-button--default {
  border: 1px solid #ec6a1a;
  color: #ec6a1a;

  &:hover {
    border: 1px solid #f19b66;
    color: #f19b66;
    background-color: #fff;
  }

  &:focus {
    border: 1px solid #f19b66;
    color: #f19b66;
    background-color: #fff;
  }
}
.sub .el-button--primary.is-disabled {
  background-color: #409eff;
  border: 1px solid #409eff;
}
.sub .el-button--primary {
  border: 1px solid #409eff;
  color: #fff;
  background-color: #409eff;

  &:hover {
    border: 1px solid #f19b66;
    color: #fff;
    background-color: #f19b66;
  }

  &:focus {
    border: 1px solid #f19b66;
    color: #fff;
    background-color: #f19b66;
  }
}

// 所有内页顶部区域头
.head-section {
  width: 100%;
  height: $navHeight;
  line-height: $navHeight;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 16px;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: white;
  position: relative;
  box-shadow: $boxShadow;
  h1 {
    margin-right: auto;
    font-size: $titleSize;
  }
  p {
    color: #909399;
    padding-right: 12px;
  }

  .el-checkbox {
    margin-right: 12px !important;
  }
}
.public-divider {
  height: 20px;
  background: #f2f6f9;
}
.el-tree-node__content {
  .el-tree-node__expand-icon {
    color: #333333;
    font-size: 18px;
  }
}
.noBorder {
  .el-dialog__header {
    border-bottom-color: transparent;
  }
  .el-dialog {
    margin-top: 30vh !important;
  }
  .el-dialog__body {
    padding: 15px;
  }
}
.move {
  cursor: move;
}
body {
  .el-textarea .el-input__count {
    color: rgb(19 20 20 / 40%);
    background: transparent !important;
  }
  .el-input .el-input__count .el-input__count-inner {
    color: rgb(19 20 20 / 40%);
    background: transparent;
  }
}
.inputSpan {
  width: 100%;
  display: inline-block;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  background-color: white;
  min-height: 40px;
  position: relative;
  cursor: pointer;

  .span-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 5px 5px 5px 5px !important;
    box-sizing: border-box;
    position: relative;
    min-height: 40px;
    align-items: center;
    .span-label {
      line-height: 30px;
      color: #c0c4cc;
      font-size: 14px;
      padding-left: 10px;
    }
    .menu {
      height: 24px;
      line-height: 24px;
      display: inline-flex !important;
      background-color: #f4f4f5;
      margin: 2px 0px 2px 6px;
      padding: 0 4px 0 8px;
      border-radius: 4px;
      cursor: text;
      align-items: center;
      .name {
        color: #8f9299;
        font-size: 12px;
        font-weight: 400;
        margin-right: 4px;
        max-width: 395px;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .el-tag.el-tag--info .el-tag__close {
        color: #8f9299;
      }

      .el-tag__close.el-icon-close {
        color: #909399;
        cursor: pointer;
        border-radius: 50%;
        font-size: 12px;
        height: 16px;
        width: 16px;
        line-height: 16px;
        text-align: center;
      }

      .el-tag__close.el-icon-close:hover {
        color: white;
        background-color: #909399;
      }
    }

    .menu.isAcv {
      .name {
        color: #ec6a1a;
        font-size: 12px;
        font-weight: 400;
        margin-right: 4px;
      }
    }

    .el-input {
      flex-grow: 1;
      height: 30px;
      line-height: 30px;
      .el-input__inner {
        border: 0;
        height: 30px;
        line-height: 30px;
      }
    }
  }

  .drop-down-icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translate(0, -50%);
  }
}
.el-table {
  thead tr th {
    background-color: #f7f7f7ff !important;
  }
  td.el-table__cell {
    // display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    // overflow: hidden;
    // text-overflow: ellipsis; /* 超出部分省略号 */
    // word-break: break-all; /* break-all(允许在单词内换行。) */
    // display: -webkit-box; /* 对象作为伸缩盒子模型显示 */
    // -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
    // -webkit-line-clamp: 2;

    div {
      overflow: hidden;
      text-overflow: ellipsis; /* 超出部分省略号 */
      word-break: break-all; /* break-all(允许在单词内换行。) */
      display: -webkit-box; /* 对象作为伸缩盒子模型显示 */
      -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
      -webkit-line-clamp: 2;
    }
  }

  .table-material {
    display: flex !important;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    .el-image {
      width: 80px;
      height: 80px;
      flex-shrink: 0;
    }
  }
}

.el-icon--top {
  .el-link--inner {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.el-popconfirm__action {
  margin-top: 15px !important;
}

.el-button--small {
  padding: 8px 15px !important;
}

.all-page-title {
  display: flex;
  width: 100%;
  align-items: center;
  flex-shrink: 0;
  padding: 5px 10px;

  p {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }

  .xie {
    font-size: 20px;
    margin: 0 10px;
  }

  h1 {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    flex-grow: 1;
  }

  .search-box {
    margin-right: 10px;
  }
}

.hui-main {
  display: flex;
  flex-direction: column;
  height: 100%;

  .choose-box {
    display: flex;
    width: 100%;
    padding: 10px;

    .choose {
      display: flex;
      align-items: center;
      margin-right: 1.1%;
      width: 18.5%;
      margin-bottom: 10px;

      .tit {
        flex-shrink: 0;
        margin-right: 5px;
      }

      .el-input,
      .el-select,
      .el-date-editor--time-select,
      .el-cascader {
        flex-grow: 1;
      }

      &:nth-child(10n) {
        margin-right: 0;
      }
    }

    .width-big {
      width: 300px;
    }

    .hui-btns {
      display: flex;
      height: 40px;
    }
  }

  .tale-box {
    margin-top: 10px;
    height: 0;
    flex-grow: 1;
    overflow-y: scroll;
  }
}
/*.chou-ti-form-box

  */
.chou-ti-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .chou-ti-title {
    height: 50px;
    line-height: 50px;
    font-size: 22px;
    font-weight: bold;
    padding-left: 10px;
  }

  .chou-ti-top-box {
    width: 94%;
    margin: 0 auto;
  }

  .chou-ti-center-box {
    flex-grow: 1;
    height: 0px;
    overflow-y: scroll;
    padding: 0 10px;

    .img-box {
      display: flex;
      flex-wrap: wrap;

      .img-del-box {
        position: relative;
        line-height: normal;
        margin-right: 10px;
        width: 128px;
        height: 128px;

        .el-image {
          width: 100%;
          height: 100%;
        }

        .delete {
          display: none;
          position: absolute;
          top: 0;
          right: 0;
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          color: #fff;
          background-color: #f00;
          z-index: 9;
        }

        &:hover {
          .delete {
            display: block;
          }
        }
      }

      .tip {
        color: #acacac;
        height: 30px;
        line-height: 30px;
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }

    .choose-btn {
      margin-left: 10px;
    }
  }

  .chouti-btn-box {
    padding: 10px;
  }
}

.no-data {
  width: 100%;
  text-align: center;
  height: 40px;
  line-height: 40px;
  color: #a9a9a9;
}

.link-box {
  display: flex;
  flex-wrap: wrap;
  .el-link {
    margin-right: 10px;
    flex-shrink: 0;
  }
}

//橙色
.orange.el-button--primary.is-plain {
  color: #ec6a1a;
  //background-color: #fff;
  background: rgba(236, 106, 26, 0.1);
  //border: 1px solid #ec6a1a;
  border: 1px solid rgba(174, 134, 110, 0.2);

  &:hover {
    color: #fff;
    background-color: #e38246;
    border: 1px solid #e38246;
  }

  &:focus {
    color: #fff;
    background-color: #e38246;
    border: 1px solid #e38246;
  }
}
.orange.el-button--default {
  border: 1px solid #ec6a1a;
  color: #ec6a1a;

  &:hover {
    border: 1px solid #f19b66;
    color: #f19b66;
    background-color: #fff;
  }

  &:focus {
    border: 1px solid #f19b66;
    color: #f19b66;
    background-color: #fff;
  }
}
.orange.el-button--primary.is-disabled {
  background-color: #e5baa0;
  border: 1px solid #e5baa0;
  &:hover {
    background-color: #e5baa0;
    border: 1px solid #e5baa0;
  }
}
.orange.el-button--primary {
  border: 1px solid #ec6a1a;
  color: #fff;
  background-color: #ec6a1a;

  &:hover {
    border: 1px solid #f19b66;
    color: #fff;
    background-color: #f19b66;
  }

  &:focus {
    border: 1px solid #f19b66;
    color: #fff;
    background-color: #f19b66;
  }
}

.over-scroll {
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: #999;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
}

.over-scroll-x {
  overflow-x: scroll;
  &::-webkit-scrollbar {
    height: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: #999;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
}

// .el-table__body-wrapper{
//   background-color: #999;
// }
.el-table__body-wrapper {
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: #999;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  }
}

.public-title {
  position: relative;
  width: 100%;
  color: #131414;
  font-size: 16px;
  padding: 12px;
  font-weight: bold;

  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    width: 4px;
    height: 11px;
    background-color: #ec6a1a;
    border-radius: 2px;
    transform: translate(0, -50%);
  }
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  &2 {
    -webkit-line-clamp: 2;
  }
  &3 {
    -webkit-line-clamp: 3;
  }
}
.el-dialog__header {
  border-bottom: 1px solid #dcdfe6;
  margin: 0 15px;
  padding: 20px 0 10px 0;
}
.imageDialog {
  .el-dialog__header {
    border-bottom: 1px solid #dcdfe6;
    margin: 0;
    padding: 20px 15px 10px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
//点
.offline::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: #999999;
  display: inline-block;
  margin-right: 8px;
}

.online::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: #00b578;
  display: inline-block;
  margin-right: 8px;
}

.waiting::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: #ec6a1a;
  display: inline-block;
  margin-right: 8px;
}

.one-link-box {
  margin-top: 5px;
  margin-bottom: 5px;
  .el-link {
    width: 100%;
  }
}

.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #ec6a1a;
  background-color: #ffefe5;
  border-color: #ec6a1a;
  box-shadow: -1px 0 0 0 #ec6a1a;
}

.el-pager li.active {
  color: #ec6a1a !important;
}
.el-link.el-link--primary {
  color: #3b72cc !important;
}
.el-message {
  min-width: auto !important;
  max-width: 400px !important;
  padding: 12px 40px !important;
  .el-message__content {
    line-height: 1.5;
  }
}
</style>
